"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
var makeCircularProgressStyling_1 = __importDefault(require("./makeCircularProgressStyling"));
var react_1 = require("@emotion/react");
var CircularProgress = function () {
    return ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { css: (0, makeCircularProgressStyling_1.default)((0, react_1.useTheme)()), size: "25px" }));
};
exports.default = CircularProgress;
//# sourceMappingURL=CircularProgress.js.map